var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import notification from 'antd/lib/notification';
import dayjs from 'dayjs';
import { ManagerQuery, StoreQuery } from 'renderer/queries';
import { LambdaClient, uniqBy } from 'renderer/utils';
import { DATE_FORMAT } from 'renderer/constants';
import React from 'react';
import Button from 'antd/lib/button';
export var syncNaverCalendar = function (params, hideNotification) { return __awaiter(void 0, void 0, void 0, function () {
    var store, managers, shouldBlockNaver, effectedDates, START_NOTI, effectedDateString, err_1, key_1, btn;
    var _a, _b, _c, _d, _e;
    return __generator(this, function (_f) {
        switch (_f.label) {
            case 0:
                store = params.store, managers = params.managers;
                if (!store) {
                    store = StoreQuery.getMyStoreInCache();
                }
                if (!(store === null || store === void 0 ? void 0 : store.isOfficialNaver)) {
                    return [2 /*return*/];
                }
                if (!managers) {
                    managers = ManagerQuery.getManagersInCache();
                }
                shouldBlockNaver = (_c = (_b = (_a = store.preference) === null || _a === void 0 ? void 0 : _a.smartplace) === null || _b === void 0 ? void 0 : _b.blockSettings) === null || _c === void 0 ? void 0 : _c.isActive;
                if (!shouldBlockNaver) {
                    return [2 /*return*/];
                }
                effectedDates = uniqBy((_e = (_d = params.effectedDates) === null || _d === void 0 ? void 0 : _d.filter(Boolean)) === null || _e === void 0 ? void 0 : _e.map(function (item) {
                    if (typeof item === 'string') {
                        item = dayjs(item).toDate();
                    }
                    return item;
                }), function (dateItem) { return dayjs(dateItem).format('YYYYMMDD'); }).filter(function (item) { return !dayjs(item).isBefore(dayjs(), 'date'); }) || [];
                if (effectedDates.length === 0) {
                    return [2 /*return*/];
                }
                START_NOTI = 'START_NOTI';
                effectedDateString = effectedDates.map(function (item) { return dayjs(item).format(DATE_FORMAT); }).join(', ');
                _f.label = 1;
            case 1:
                _f.trys.push([1, 3, , 4]);
                return [4 /*yield*/, LambdaClient.getInstance()
                        .post('/sync/calendar', {
                        storeId: store.id,
                        targetDates: effectedDates
                    })
                        .then(function () {
                        if (hideNotification) {
                            return;
                        }
                        notification.info({
                            placement: 'topLeft',
                            message: "\uB124\uC774\uBC84 \uAC04\uB2E8\uC608\uC57D\uAD00\uB9AC \uB3D9\uAE30\uD654 \uC131\uACF5(".concat(effectedDateString, ")")
                            // description: '이제 다시 예약을 수정하거나 만들 수 있습니다.'
                        });
                    })];
            case 2:
                _f.sent();
                return [3 /*break*/, 4];
            case 3:
                err_1 = _f.sent();
                notification.destroy(START_NOTI);
                if (hideNotification) {
                    return [2 /*return*/];
                }
                key_1 = "open".concat(Date.now());
                btn = (React.createElement(Button, { type: "primary", size: "small", onClick: function () {
                        notification.destroy(key_1);
                    } }, "\uC7AC\uC2DC\uB3C4"));
                notification.error({
                    key: key_1,
                    placement: 'topLeft',
                    message: "\uB124\uC774\uBC84 \uAC04\uB2E8\uC608\uC57D\uAD00\uB9AC \uB3D9\uAE30\uD654 \uC2E4\uD328(".concat(effectedDateString, ")"),
                    description: '네이버예약막기를 다시 한번 시도해주세요.',
                    btn: btn,
                    duration: 0
                });
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); };
